"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagingSetLineData = void 0;
class PackagingSetLineData {
}
exports.PackagingSetLineData = PackagingSetLineData;
//# sourceMappingURL=packaging-set-line-data.response.js.map